import '@reach/dialog/styles.css';
import cx from 'classnames';
import * as React from 'react';
import { Footer } from './footer';
import { Header } from './header';
import { LangLink } from './lang-link';
import styles from './layout.module.scss';
import { useLocalize } from './localize-context';
import { Sidebar } from './sidebar';

export const Layout = ({ children }: { children: React.ReactNode }) => {
  const [showSidebar, setShowSetbar] = React.useState(false);
  const toggleSidebar = () => setShowSetbar(show => !show);

  return (
    <>
      <Sidebar open={showSidebar} onClose={() => setShowSetbar(false)}>
        <SidebarContent onLinkClick={() => setShowSetbar(false)} />
      </Sidebar>
      <Header onToggleSidebar={toggleSidebar} />
      <main className={styles.main} id="content-root">
        {children}
      </main>
      <Footer />
    </>
  );
};

function SidebarContent({ onLinkClick }: { onLinkClick: () => void }) {
  const localize = useLocalize();

  return (
    <nav
      className="text-right"
      style={{
        minWidth: 200,
      }}
    >
      <div className="p-4 bg-blue-700">
        <LangLink className="p-2 text-gray-100" to="/" onClick={onLinkClick}>
          {localize('D Tours: Sky Mirror')}
        </LangLink>
      </div>
      <ul className="py-2">
        <li>
          <NavLink to="/package" onClick={onLinkClick}>
            {localize('Packages')}
          </NavLink>
        </li>
        <li>
          <NavLink to="/combo" onClick={onLinkClick}>
            {localize('Combo')}
          </NavLink>
        </li>
        <li>
          <NavLink to="/itinerary" onClick={onLinkClick}>
            {localize('Itinerary')}
          </NavLink>
        </li>
        <li>
          <NavLink to="/rate" onClick={onLinkClick}>
            {localize('Rates')}
          </NavLink>
        </li>
        <li>
          <NavLink to="/reminder" onClick={onLinkClick}>
            {localize('Reminders')}
          </NavLink>
        </li>
        <li>
          <NavLink to="/album" onClick={onLinkClick}>
            {localize('Album')}
          </NavLink>
        </li>
        <li>
          <NavLink to="/schedule" onClick={onLinkClick}>
            {localize('Departure Time')}
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}

function NavLink(props: {
  to: string;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <LangLink
      to={props.to}
      onClick={props.onClick}
      getProps={({ isCurrent }) => ({
        className: cx(
          'block py-2 px-6',
          isCurrent ? 'text-blue-600 cursor-default' : 'hover:bg-gray-200'
        ),
      })}
    >
      {props.children}
    </LangLink>
  );
}
